const {
  COOKIES, getCookie, setCookie,
} = require('./helpers');
const { BAG_EXPIRATION_DAYS } = require('./constants');
// 2h: 2 * 60 * 60 * 1000 = 7200000
const ABANDONED_CART_INTERVAL = 7_200_000;
// const ABANDONED_CART_INTERVAL = 60_000;

function isBagAbandoned() {
  const cartUpdateDate = getCookie(COOKIES.BAG_DATE);
  if (!cartUpdateDate) return false;
  const updateDate = new Date(cartUpdateDate);
  if (!updateDate) return false;
  const difference = Date.now() - Date.parse(updateDate);
  return difference > ABANDONED_CART_INTERVAL;
}

function updateBagDate() {
  setCookie(COOKIES.BAG_DATE, new Date().toISOString(), BAG_EXPIRATION_DAYS);
}

function setBagCookies({ hash, market }) {
  setCookie(COOKIES.BAG, encodeURI(hash), BAG_EXPIRATION_DAYS);
  setCookie(COOKIES.BAG_MARKET, market, BAG_EXPIRATION_DAYS);
  updateBagDate();
}

module.exports = {
  isBagAbandoned,
  setBagCookies,
  updateBagDate,
};
